// @ts-nocheck
/* eslint-disable */
import { HardwareSpecs, HardwareSpecsAmino, Info, InfoAmino, Lease, LeaseAmino } from "./medianode";
import { Coin, CoinAmino } from "../../cosmos/base/v1beta1/coin";
import { Params, ParamsAmino } from "./params";
import { BinaryReader, BinaryWriter } from "../../deps/binary";
import { DeepPartial, Exact, Rpc } from "../../deps/helpers";
export const protobufPackage = "OmniFlix.medianode.v1beta1";
/** MsgRegisterMediaNode represents a message to register a new media node */
export interface MsgRegisterMediaNode {
  id: string;
  url: string;
  hardwareSpecs: HardwareSpecs;
  pricePerHour: Coin;
  deposit?: Coin;
  sender: string;
  info: Info;
}
export interface MsgRegisterMediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNode";
  value: Uint8Array;
}
/** MsgRegisterMediaNode represents a message to register a new media node */
export interface MsgRegisterMediaNodeAmino {
  id?: string;
  url?: string;
  hardware_specs?: HardwareSpecsAmino;
  price_per_hour?: CoinAmino;
  deposit?: CoinAmino;
  sender?: string;
  info?: InfoAmino;
}
export interface MsgRegisterMediaNodeAminoMsg {
  type: "OmniFlix/register-medianode";
  value: MsgRegisterMediaNodeAmino;
}
/** MsgRegisterMediaNodeResponse defines the response for registering a media node */
export interface MsgRegisterMediaNodeResponse {
  /** ID of the registered media node */
  mediaNodeId: string;
  /** Status of the registration */
  status: string;
}
export interface MsgRegisterMediaNodeResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNodeResponse";
  value: Uint8Array;
}
/** MsgRegisterMediaNodeResponse defines the response for registering a media node */
export interface MsgRegisterMediaNodeResponseAmino {
  /** ID of the registered media node */
  media_node_id?: string;
  /** Status of the registration */
  status?: string;
}
export interface MsgRegisterMediaNodeResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNodeResponse";
  value: MsgRegisterMediaNodeResponseAmino;
}
/** MsgUpdateMediaNode represents a message to update an existing media node only if it's not leased */
export interface MsgUpdateMediaNode {
  id: string;
  hardwareSpecs?: HardwareSpecs;
  pricePerHour?: Coin;
  info?: Info;
  sender: string;
}
export interface MsgUpdateMediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNode";
  value: Uint8Array;
}
/** MsgUpdateMediaNode represents a message to update an existing media node only if it's not leased */
export interface MsgUpdateMediaNodeAmino {
  id?: string;
  hardware_specs?: HardwareSpecsAmino;
  price_per_hour?: CoinAmino;
  info?: InfoAmino;
  sender?: string;
}
export interface MsgUpdateMediaNodeAminoMsg {
  type: "OmniFlix/update-medianode";
  value: MsgUpdateMediaNodeAmino;
}
/** MsgUpdateMediaNodeResponse defines the response for updating a media node */
export interface MsgUpdateMediaNodeResponse {}
export interface MsgUpdateMediaNodeResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNodeResponse";
  value: Uint8Array;
}
/** MsgUpdateMediaNodeResponse defines the response for updating a media node */
export interface MsgUpdateMediaNodeResponseAmino {}
export interface MsgUpdateMediaNodeResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNodeResponse";
  value: MsgUpdateMediaNodeResponseAmino;
}
/** MsgLeaseMediaNode represents a message to lease a media node */
export interface MsgLeaseMediaNode {
  mediaNodeId: string;
  leaseHours: bigint;
  amount: Coin;
  sender: string;
}
export interface MsgLeaseMediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNode";
  value: Uint8Array;
}
/** MsgLeaseMediaNode represents a message to lease a media node */
export interface MsgLeaseMediaNodeAmino {
  media_node_id?: string;
  lease_hours?: string;
  amount?: CoinAmino;
  sender?: string;
}
export interface MsgLeaseMediaNodeAminoMsg {
  type: "OmniFlix/lease-medianode";
  value: MsgLeaseMediaNodeAmino;
}
/** MsgLeaseMediaNodeResponse defines the response for leasing a media node */
export interface MsgLeaseMediaNodeResponse {
  lease?: Lease;
}
export interface MsgLeaseMediaNodeResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNodeResponse";
  value: Uint8Array;
}
/** MsgLeaseMediaNodeResponse defines the response for leasing a media node */
export interface MsgLeaseMediaNodeResponseAmino {
  lease?: LeaseAmino;
}
export interface MsgLeaseMediaNodeResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNodeResponse";
  value: MsgLeaseMediaNodeResponseAmino;
}
/** MsgExtendLease represents a message to extend lease duration */
export interface MsgExtendLease {
  mediaNodeId: string;
  leaseHours: bigint;
  amount: Coin;
  sender: string;
}
export interface MsgExtendLeaseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLease";
  value: Uint8Array;
}
/** MsgExtendLease represents a message to extend lease duration */
export interface MsgExtendLeaseAmino {
  media_node_id?: string;
  lease_hours?: string;
  amount?: CoinAmino;
  sender?: string;
}
export interface MsgExtendLeaseAminoMsg {
  type: "OmniFlix/extend-medianode-lease";
  value: MsgExtendLeaseAmino;
}
export interface MsgExtendLeaseResponse {
  lease?: Lease;
}
export interface MsgExtendLeaseResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLeaseResponse";
  value: Uint8Array;
}
export interface MsgExtendLeaseResponseAmino {
  lease?: LeaseAmino;
}
export interface MsgExtendLeaseResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgExtendLeaseResponse";
  value: MsgExtendLeaseResponseAmino;
}
/** MsgCancelLease represents a message to cancel an active lease */
export interface MsgCancelLease {
  mediaNodeId: string;
  sender: string;
}
export interface MsgCancelLeaseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLease";
  value: Uint8Array;
}
/** MsgCancelLease represents a message to cancel an active lease */
export interface MsgCancelLeaseAmino {
  media_node_id?: string;
  sender?: string;
}
export interface MsgCancelLeaseAminoMsg {
  type: "OmniFlix/cancel-medianode-lease";
  value: MsgCancelLeaseAmino;
}
/** MsgCancelLeaseResponse defines the response for canceling a lease */
export interface MsgCancelLeaseResponse {}
export interface MsgCancelLeaseResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLeaseResponse";
  value: Uint8Array;
}
/** MsgCancelLeaseResponse defines the response for canceling a lease */
export interface MsgCancelLeaseResponseAmino {}
export interface MsgCancelLeaseResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgCancelLeaseResponse";
  value: MsgCancelLeaseResponseAmino;
}
/** MsgDepositMediaNode represents a message to deposit funds for a media node */
export interface MsgDepositMediaNode {
  /** ID of the media node */
  mediaNodeId: string;
  /** Amount to deposit */
  amount: Coin;
  /** Address of the sender */
  sender: string;
}
export interface MsgDepositMediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNode";
  value: Uint8Array;
}
/** MsgDepositMediaNode represents a message to deposit funds for a media node */
export interface MsgDepositMediaNodeAmino {
  /** ID of the media node */
  media_node_id?: string;
  /** Amount to deposit */
  amount?: CoinAmino;
  /** Address of the sender */
  sender?: string;
}
export interface MsgDepositMediaNodeAminoMsg {
  type: "OmniFlix/deposit-medianode";
  value: MsgDepositMediaNodeAmino;
}
/** MsgDepositMediaNodeResponse defines the response for depositing funds for a media node */
export interface MsgDepositMediaNodeResponse {
  medianodeId: string;
  totalDeposit?: Coin;
  medianodeStatus: string;
}
export interface MsgDepositMediaNodeResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNodeResponse";
  value: Uint8Array;
}
/** MsgDepositMediaNodeResponse defines the response for depositing funds for a media node */
export interface MsgDepositMediaNodeResponseAmino {
  medianode_id?: string;
  total_deposit?: CoinAmino;
  medianode_status?: string;
}
export interface MsgDepositMediaNodeResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNodeResponse";
  value: MsgDepositMediaNodeResponseAmino;
}
/** MsgCloseMediaNode represents a message to close a media node */
export interface MsgCloseMediaNode {
  /** ID of the media node */
  mediaNodeId: string;
  /** Address of the sender */
  sender: string;
}
export interface MsgCloseMediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNode";
  value: Uint8Array;
}
/** MsgCloseMediaNode represents a message to close a media node */
export interface MsgCloseMediaNodeAmino {
  /** ID of the media node */
  media_node_id?: string;
  /** Address of the sender */
  sender?: string;
}
export interface MsgCloseMediaNodeAminoMsg {
  type: "OmniFlix/close-medianode";
  value: MsgCloseMediaNodeAmino;
}
export interface MsgCloseMediaNodeResponse {}
export interface MsgCloseMediaNodeResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNodeResponse";
  value: Uint8Array;
}
export interface MsgCloseMediaNodeResponseAmino {}
export interface MsgCloseMediaNodeResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNodeResponse";
  value: MsgCloseMediaNodeResponseAmino;
}
export interface MsgUpdateParams {
  /** authority is the address of the governance account. */
  authority: string;
  /**
   * params defines the x/itc parameters to update.
   * 
   * NOTE: All parameters must be supplied.
   */
  params: Params;
}
export interface MsgUpdateParamsProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParams";
  value: Uint8Array;
}
export interface MsgUpdateParamsAmino {
  /** authority is the address of the governance account. */
  authority?: string;
  /**
   * params defines the x/itc parameters to update.
   * 
   * NOTE: All parameters must be supplied.
   */
  params?: ParamsAmino;
}
export interface MsgUpdateParamsAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgUpdateParams";
  value: MsgUpdateParamsAmino;
}
/**
 * MsgUpdateParamsResponse defines the response structure for executing a
 * MsgUpdateParams message.
 * 
 * Since: cosmos-sdk 0.47
 */
export interface MsgUpdateParamsResponse {}
export interface MsgUpdateParamsResponseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParamsResponse";
  value: Uint8Array;
}
/**
 * MsgUpdateParamsResponse defines the response structure for executing a
 * MsgUpdateParams message.
 * 
 * Since: cosmos-sdk 0.47
 */
export interface MsgUpdateParamsResponseAmino {}
export interface MsgUpdateParamsResponseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MsgUpdateParamsResponse";
  value: MsgUpdateParamsResponseAmino;
}
function createBaseMsgRegisterMediaNode(): MsgRegisterMediaNode {
  return {
    id: "",
    url: "",
    hardwareSpecs: HardwareSpecs.fromPartial({}),
    pricePerHour: Coin.fromPartial({}),
    deposit: undefined,
    sender: "",
    info: Info.fromPartial({})
  };
}
export const MsgRegisterMediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNode",
  encode(message: MsgRegisterMediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.hardwareSpecs !== undefined) {
      HardwareSpecs.encode(message.hardwareSpecs, writer.uint32(26).fork()).ldelim();
    }
    if (message.pricePerHour !== undefined) {
      Coin.encode(message.pricePerHour, writer.uint32(34).fork()).ldelim();
    }
    if (message.deposit !== undefined) {
      Coin.encode(message.deposit, writer.uint32(42).fork()).ldelim();
    }
    if (message.sender !== "") {
      writer.uint32(50).string(message.sender);
    }
    if (message.info !== undefined) {
      Info.encode(message.info, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgRegisterMediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.url = reader.string();
          break;
        case 3:
          message.hardwareSpecs = HardwareSpecs.decode(reader, reader.uint32());
          break;
        case 4:
          message.pricePerHour = Coin.decode(reader, reader.uint32());
          break;
        case 5:
          message.deposit = Coin.decode(reader, reader.uint32());
          break;
        case 6:
          message.sender = reader.string();
          break;
        case 7:
          message.info = Info.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgRegisterMediaNode>, I>>(object: I): MsgRegisterMediaNode {
    const message = createBaseMsgRegisterMediaNode();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    if (object.hardwareSpecs !== undefined && object.hardwareSpecs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromPartial(object.hardwareSpecs);
    }
    if (object.pricePerHour !== undefined && object.pricePerHour !== null) {
      message.pricePerHour = Coin.fromPartial(object.pricePerHour);
    }
    if (object.deposit !== undefined && object.deposit !== null) {
      message.deposit = Coin.fromPartial(object.deposit);
    }
    message.sender = object.sender ?? "";
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromPartial(object.info);
    }
    return message;
  },
  fromAmino(object: MsgRegisterMediaNodeAmino): MsgRegisterMediaNode {
    const message = createBaseMsgRegisterMediaNode();
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    }
    if (object.url !== undefined && object.url !== null) {
      message.url = object.url;
    }
    if (object.hardware_specs !== undefined && object.hardware_specs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromAmino(object.hardware_specs);
    }
    if (object.price_per_hour !== undefined && object.price_per_hour !== null) {
      message.pricePerHour = Coin.fromAmino(object.price_per_hour);
    }
    if (object.deposit !== undefined && object.deposit !== null) {
      message.deposit = Coin.fromAmino(object.deposit);
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromAmino(object.info);
    }
    return message;
  },
  toAmino(message: MsgRegisterMediaNode): MsgRegisterMediaNodeAmino {
    const obj: any = {};
    obj.id = message.id === "" ? undefined : message.id;
    obj.url = message.url === "" ? undefined : message.url;
    obj.hardware_specs = message.hardwareSpecs ? HardwareSpecs.toAmino(message.hardwareSpecs) : undefined;
    obj.price_per_hour = message.pricePerHour ? Coin.toAmino(message.pricePerHour) : undefined;
    obj.deposit = message.deposit ? Coin.toAmino(message.deposit) : undefined;
    obj.sender = message.sender === "" ? undefined : message.sender;
    obj.info = message.info ? Info.toAmino(message.info) : undefined;
    return obj;
  },
  fromAminoMsg(object: MsgRegisterMediaNodeAminoMsg): MsgRegisterMediaNode {
    return MsgRegisterMediaNode.fromAmino(object.value);
  },
  toAminoMsg(message: MsgRegisterMediaNode): MsgRegisterMediaNodeAminoMsg {
    return {
      type: "OmniFlix/register-medianode",
      value: MsgRegisterMediaNode.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgRegisterMediaNodeProtoMsg): MsgRegisterMediaNode {
    return MsgRegisterMediaNode.decode(message.value);
  },
  toProto(message: MsgRegisterMediaNode): Uint8Array {
    return MsgRegisterMediaNode.encode(message).finish();
  },
  toProtoMsg(message: MsgRegisterMediaNode): MsgRegisterMediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNode",
      value: MsgRegisterMediaNode.encode(message).finish()
    };
  }
};
function createBaseMsgRegisterMediaNodeResponse(): MsgRegisterMediaNodeResponse {
  return {
    mediaNodeId: "",
    status: ""
  };
}
export const MsgRegisterMediaNodeResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNodeResponse",
  encode(message: MsgRegisterMediaNodeResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgRegisterMediaNodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRegisterMediaNodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.status = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgRegisterMediaNodeResponse>, I>>(object: I): MsgRegisterMediaNodeResponse {
    const message = createBaseMsgRegisterMediaNodeResponse();
    message.mediaNodeId = object.mediaNodeId ?? "";
    message.status = object.status ?? "";
    return message;
  },
  fromAmino(object: MsgRegisterMediaNodeResponseAmino): MsgRegisterMediaNodeResponse {
    const message = createBaseMsgRegisterMediaNodeResponse();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.status !== undefined && object.status !== null) {
      message.status = object.status;
    }
    return message;
  },
  toAmino(message: MsgRegisterMediaNodeResponse): MsgRegisterMediaNodeResponseAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.status = message.status === "" ? undefined : message.status;
    return obj;
  },
  fromAminoMsg(object: MsgRegisterMediaNodeResponseAminoMsg): MsgRegisterMediaNodeResponse {
    return MsgRegisterMediaNodeResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgRegisterMediaNodeResponseProtoMsg): MsgRegisterMediaNodeResponse {
    return MsgRegisterMediaNodeResponse.decode(message.value);
  },
  toProto(message: MsgRegisterMediaNodeResponse): Uint8Array {
    return MsgRegisterMediaNodeResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgRegisterMediaNodeResponse): MsgRegisterMediaNodeResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNodeResponse",
      value: MsgRegisterMediaNodeResponse.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateMediaNode(): MsgUpdateMediaNode {
  return {
    id: "",
    hardwareSpecs: undefined,
    pricePerHour: undefined,
    info: undefined,
    sender: ""
  };
}
export const MsgUpdateMediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNode",
  encode(message: MsgUpdateMediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.hardwareSpecs !== undefined) {
      HardwareSpecs.encode(message.hardwareSpecs, writer.uint32(18).fork()).ldelim();
    }
    if (message.pricePerHour !== undefined) {
      Coin.encode(message.pricePerHour, writer.uint32(26).fork()).ldelim();
    }
    if (message.info !== undefined) {
      Info.encode(message.info, writer.uint32(34).fork()).ldelim();
    }
    if (message.sender !== "") {
      writer.uint32(42).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateMediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.hardwareSpecs = HardwareSpecs.decode(reader, reader.uint32());
          break;
        case 3:
          message.pricePerHour = Coin.decode(reader, reader.uint32());
          break;
        case 4:
          message.info = Info.decode(reader, reader.uint32());
          break;
        case 5:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateMediaNode>, I>>(object: I): MsgUpdateMediaNode {
    const message = createBaseMsgUpdateMediaNode();
    message.id = object.id ?? "";
    if (object.hardwareSpecs !== undefined && object.hardwareSpecs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromPartial(object.hardwareSpecs);
    }
    if (object.pricePerHour !== undefined && object.pricePerHour !== null) {
      message.pricePerHour = Coin.fromPartial(object.pricePerHour);
    }
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromPartial(object.info);
    }
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgUpdateMediaNodeAmino): MsgUpdateMediaNode {
    const message = createBaseMsgUpdateMediaNode();
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    }
    if (object.hardware_specs !== undefined && object.hardware_specs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromAmino(object.hardware_specs);
    }
    if (object.price_per_hour !== undefined && object.price_per_hour !== null) {
      message.pricePerHour = Coin.fromAmino(object.price_per_hour);
    }
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromAmino(object.info);
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgUpdateMediaNode): MsgUpdateMediaNodeAmino {
    const obj: any = {};
    obj.id = message.id === "" ? undefined : message.id;
    obj.hardware_specs = message.hardwareSpecs ? HardwareSpecs.toAmino(message.hardwareSpecs) : undefined;
    obj.price_per_hour = message.pricePerHour ? Coin.toAmino(message.pricePerHour) : undefined;
    obj.info = message.info ? Info.toAmino(message.info) : undefined;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgUpdateMediaNodeAminoMsg): MsgUpdateMediaNode {
    return MsgUpdateMediaNode.fromAmino(object.value);
  },
  toAminoMsg(message: MsgUpdateMediaNode): MsgUpdateMediaNodeAminoMsg {
    return {
      type: "OmniFlix/update-medianode",
      value: MsgUpdateMediaNode.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgUpdateMediaNodeProtoMsg): MsgUpdateMediaNode {
    return MsgUpdateMediaNode.decode(message.value);
  },
  toProto(message: MsgUpdateMediaNode): Uint8Array {
    return MsgUpdateMediaNode.encode(message).finish();
  },
  toProtoMsg(message: MsgUpdateMediaNode): MsgUpdateMediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNode",
      value: MsgUpdateMediaNode.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateMediaNodeResponse(): MsgUpdateMediaNodeResponse {
  return {};
}
export const MsgUpdateMediaNodeResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNodeResponse",
  encode(_: MsgUpdateMediaNodeResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateMediaNodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateMediaNodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateMediaNodeResponse>, I>>(_: I): MsgUpdateMediaNodeResponse {
    const message = createBaseMsgUpdateMediaNodeResponse();
    return message;
  },
  fromAmino(_: MsgUpdateMediaNodeResponseAmino): MsgUpdateMediaNodeResponse {
    const message = createBaseMsgUpdateMediaNodeResponse();
    return message;
  },
  toAmino(_: MsgUpdateMediaNodeResponse): MsgUpdateMediaNodeResponseAmino {
    const obj: any = {};
    return obj;
  },
  fromAminoMsg(object: MsgUpdateMediaNodeResponseAminoMsg): MsgUpdateMediaNodeResponse {
    return MsgUpdateMediaNodeResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgUpdateMediaNodeResponseProtoMsg): MsgUpdateMediaNodeResponse {
    return MsgUpdateMediaNodeResponse.decode(message.value);
  },
  toProto(message: MsgUpdateMediaNodeResponse): Uint8Array {
    return MsgUpdateMediaNodeResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgUpdateMediaNodeResponse): MsgUpdateMediaNodeResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNodeResponse",
      value: MsgUpdateMediaNodeResponse.encode(message).finish()
    };
  }
};
function createBaseMsgLeaseMediaNode(): MsgLeaseMediaNode {
  return {
    mediaNodeId: "",
    leaseHours: BigInt(0),
    amount: Coin.fromPartial({}),
    sender: ""
  };
}
export const MsgLeaseMediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNode",
  encode(message: MsgLeaseMediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.leaseHours !== BigInt(0)) {
      writer.uint32(16).uint64(message.leaseHours);
    }
    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
    }
    if (message.sender !== "") {
      writer.uint32(34).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgLeaseMediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLeaseMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.leaseHours = reader.uint64();
          break;
        case 3:
          message.amount = Coin.decode(reader, reader.uint32());
          break;
        case 4:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgLeaseMediaNode>, I>>(object: I): MsgLeaseMediaNode {
    const message = createBaseMsgLeaseMediaNode();
    message.mediaNodeId = object.mediaNodeId ?? "";
    if (object.leaseHours !== undefined && object.leaseHours !== null) {
      message.leaseHours = BigInt(object.leaseHours.toString());
    }
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromPartial(object.amount);
    }
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgLeaseMediaNodeAmino): MsgLeaseMediaNode {
    const message = createBaseMsgLeaseMediaNode();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.lease_hours !== undefined && object.lease_hours !== null) {
      message.leaseHours = BigInt(object.lease_hours);
    }
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromAmino(object.amount);
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgLeaseMediaNode): MsgLeaseMediaNodeAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.lease_hours = message.leaseHours !== BigInt(0) ? message.leaseHours?.toString() : undefined;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgLeaseMediaNodeAminoMsg): MsgLeaseMediaNode {
    return MsgLeaseMediaNode.fromAmino(object.value);
  },
  toAminoMsg(message: MsgLeaseMediaNode): MsgLeaseMediaNodeAminoMsg {
    return {
      type: "OmniFlix/lease-medianode",
      value: MsgLeaseMediaNode.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgLeaseMediaNodeProtoMsg): MsgLeaseMediaNode {
    return MsgLeaseMediaNode.decode(message.value);
  },
  toProto(message: MsgLeaseMediaNode): Uint8Array {
    return MsgLeaseMediaNode.encode(message).finish();
  },
  toProtoMsg(message: MsgLeaseMediaNode): MsgLeaseMediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNode",
      value: MsgLeaseMediaNode.encode(message).finish()
    };
  }
};
function createBaseMsgLeaseMediaNodeResponse(): MsgLeaseMediaNodeResponse {
  return {
    lease: undefined
  };
}
export const MsgLeaseMediaNodeResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNodeResponse",
  encode(message: MsgLeaseMediaNodeResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.lease !== undefined) {
      Lease.encode(message.lease, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgLeaseMediaNodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgLeaseMediaNodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.lease = Lease.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgLeaseMediaNodeResponse>, I>>(object: I): MsgLeaseMediaNodeResponse {
    const message = createBaseMsgLeaseMediaNodeResponse();
    if (object.lease !== undefined && object.lease !== null) {
      message.lease = Lease.fromPartial(object.lease);
    }
    return message;
  },
  fromAmino(object: MsgLeaseMediaNodeResponseAmino): MsgLeaseMediaNodeResponse {
    const message = createBaseMsgLeaseMediaNodeResponse();
    if (object.lease !== undefined && object.lease !== null) {
      message.lease = Lease.fromAmino(object.lease);
    }
    return message;
  },
  toAmino(message: MsgLeaseMediaNodeResponse): MsgLeaseMediaNodeResponseAmino {
    const obj: any = {};
    obj.lease = message.lease ? Lease.toAmino(message.lease) : undefined;
    return obj;
  },
  fromAminoMsg(object: MsgLeaseMediaNodeResponseAminoMsg): MsgLeaseMediaNodeResponse {
    return MsgLeaseMediaNodeResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgLeaseMediaNodeResponseProtoMsg): MsgLeaseMediaNodeResponse {
    return MsgLeaseMediaNodeResponse.decode(message.value);
  },
  toProto(message: MsgLeaseMediaNodeResponse): Uint8Array {
    return MsgLeaseMediaNodeResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgLeaseMediaNodeResponse): MsgLeaseMediaNodeResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNodeResponse",
      value: MsgLeaseMediaNodeResponse.encode(message).finish()
    };
  }
};
function createBaseMsgExtendLease(): MsgExtendLease {
  return {
    mediaNodeId: "",
    leaseHours: BigInt(0),
    amount: Coin.fromPartial({}),
    sender: ""
  };
}
export const MsgExtendLease = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLease",
  encode(message: MsgExtendLease, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.leaseHours !== BigInt(0)) {
      writer.uint32(16).uint64(message.leaseHours);
    }
    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
    }
    if (message.sender !== "") {
      writer.uint32(34).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgExtendLease {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExtendLease();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.leaseHours = reader.uint64();
          break;
        case 3:
          message.amount = Coin.decode(reader, reader.uint32());
          break;
        case 4:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgExtendLease>, I>>(object: I): MsgExtendLease {
    const message = createBaseMsgExtendLease();
    message.mediaNodeId = object.mediaNodeId ?? "";
    if (object.leaseHours !== undefined && object.leaseHours !== null) {
      message.leaseHours = BigInt(object.leaseHours.toString());
    }
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromPartial(object.amount);
    }
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgExtendLeaseAmino): MsgExtendLease {
    const message = createBaseMsgExtendLease();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.lease_hours !== undefined && object.lease_hours !== null) {
      message.leaseHours = BigInt(object.lease_hours);
    }
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromAmino(object.amount);
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgExtendLease): MsgExtendLeaseAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.lease_hours = message.leaseHours !== BigInt(0) ? message.leaseHours?.toString() : undefined;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgExtendLeaseAminoMsg): MsgExtendLease {
    return MsgExtendLease.fromAmino(object.value);
  },
  toAminoMsg(message: MsgExtendLease): MsgExtendLeaseAminoMsg {
    return {
      type: "OmniFlix/extend-medianode-lease",
      value: MsgExtendLease.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgExtendLeaseProtoMsg): MsgExtendLease {
    return MsgExtendLease.decode(message.value);
  },
  toProto(message: MsgExtendLease): Uint8Array {
    return MsgExtendLease.encode(message).finish();
  },
  toProtoMsg(message: MsgExtendLease): MsgExtendLeaseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLease",
      value: MsgExtendLease.encode(message).finish()
    };
  }
};
function createBaseMsgExtendLeaseResponse(): MsgExtendLeaseResponse {
  return {
    lease: undefined
  };
}
export const MsgExtendLeaseResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLeaseResponse",
  encode(message: MsgExtendLeaseResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.lease !== undefined) {
      Lease.encode(message.lease, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgExtendLeaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgExtendLeaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.lease = Lease.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgExtendLeaseResponse>, I>>(object: I): MsgExtendLeaseResponse {
    const message = createBaseMsgExtendLeaseResponse();
    if (object.lease !== undefined && object.lease !== null) {
      message.lease = Lease.fromPartial(object.lease);
    }
    return message;
  },
  fromAmino(object: MsgExtendLeaseResponseAmino): MsgExtendLeaseResponse {
    const message = createBaseMsgExtendLeaseResponse();
    if (object.lease !== undefined && object.lease !== null) {
      message.lease = Lease.fromAmino(object.lease);
    }
    return message;
  },
  toAmino(message: MsgExtendLeaseResponse): MsgExtendLeaseResponseAmino {
    const obj: any = {};
    obj.lease = message.lease ? Lease.toAmino(message.lease) : undefined;
    return obj;
  },
  fromAminoMsg(object: MsgExtendLeaseResponseAminoMsg): MsgExtendLeaseResponse {
    return MsgExtendLeaseResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgExtendLeaseResponseProtoMsg): MsgExtendLeaseResponse {
    return MsgExtendLeaseResponse.decode(message.value);
  },
  toProto(message: MsgExtendLeaseResponse): Uint8Array {
    return MsgExtendLeaseResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgExtendLeaseResponse): MsgExtendLeaseResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgExtendLeaseResponse",
      value: MsgExtendLeaseResponse.encode(message).finish()
    };
  }
};
function createBaseMsgCancelLease(): MsgCancelLease {
  return {
    mediaNodeId: "",
    sender: ""
  };
}
export const MsgCancelLease = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLease",
  encode(message: MsgCancelLease, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgCancelLease {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCancelLease();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgCancelLease>, I>>(object: I): MsgCancelLease {
    const message = createBaseMsgCancelLease();
    message.mediaNodeId = object.mediaNodeId ?? "";
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgCancelLeaseAmino): MsgCancelLease {
    const message = createBaseMsgCancelLease();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgCancelLease): MsgCancelLeaseAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgCancelLeaseAminoMsg): MsgCancelLease {
    return MsgCancelLease.fromAmino(object.value);
  },
  toAminoMsg(message: MsgCancelLease): MsgCancelLeaseAminoMsg {
    return {
      type: "OmniFlix/cancel-medianode-lease",
      value: MsgCancelLease.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgCancelLeaseProtoMsg): MsgCancelLease {
    return MsgCancelLease.decode(message.value);
  },
  toProto(message: MsgCancelLease): Uint8Array {
    return MsgCancelLease.encode(message).finish();
  },
  toProtoMsg(message: MsgCancelLease): MsgCancelLeaseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLease",
      value: MsgCancelLease.encode(message).finish()
    };
  }
};
function createBaseMsgCancelLeaseResponse(): MsgCancelLeaseResponse {
  return {};
}
export const MsgCancelLeaseResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLeaseResponse",
  encode(_: MsgCancelLeaseResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgCancelLeaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCancelLeaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgCancelLeaseResponse>, I>>(_: I): MsgCancelLeaseResponse {
    const message = createBaseMsgCancelLeaseResponse();
    return message;
  },
  fromAmino(_: MsgCancelLeaseResponseAmino): MsgCancelLeaseResponse {
    const message = createBaseMsgCancelLeaseResponse();
    return message;
  },
  toAmino(_: MsgCancelLeaseResponse): MsgCancelLeaseResponseAmino {
    const obj: any = {};
    return obj;
  },
  fromAminoMsg(object: MsgCancelLeaseResponseAminoMsg): MsgCancelLeaseResponse {
    return MsgCancelLeaseResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgCancelLeaseResponseProtoMsg): MsgCancelLeaseResponse {
    return MsgCancelLeaseResponse.decode(message.value);
  },
  toProto(message: MsgCancelLeaseResponse): Uint8Array {
    return MsgCancelLeaseResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgCancelLeaseResponse): MsgCancelLeaseResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgCancelLeaseResponse",
      value: MsgCancelLeaseResponse.encode(message).finish()
    };
  }
};
function createBaseMsgDepositMediaNode(): MsgDepositMediaNode {
  return {
    mediaNodeId: "",
    amount: Coin.fromPartial({}),
    sender: ""
  };
}
export const MsgDepositMediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNode",
  encode(message: MsgDepositMediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }
    if (message.sender !== "") {
      writer.uint32(26).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgDepositMediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDepositMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.amount = Coin.decode(reader, reader.uint32());
          break;
        case 3:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgDepositMediaNode>, I>>(object: I): MsgDepositMediaNode {
    const message = createBaseMsgDepositMediaNode();
    message.mediaNodeId = object.mediaNodeId ?? "";
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromPartial(object.amount);
    }
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgDepositMediaNodeAmino): MsgDepositMediaNode {
    const message = createBaseMsgDepositMediaNode();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromAmino(object.amount);
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgDepositMediaNode): MsgDepositMediaNodeAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgDepositMediaNodeAminoMsg): MsgDepositMediaNode {
    return MsgDepositMediaNode.fromAmino(object.value);
  },
  toAminoMsg(message: MsgDepositMediaNode): MsgDepositMediaNodeAminoMsg {
    return {
      type: "OmniFlix/deposit-medianode",
      value: MsgDepositMediaNode.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgDepositMediaNodeProtoMsg): MsgDepositMediaNode {
    return MsgDepositMediaNode.decode(message.value);
  },
  toProto(message: MsgDepositMediaNode): Uint8Array {
    return MsgDepositMediaNode.encode(message).finish();
  },
  toProtoMsg(message: MsgDepositMediaNode): MsgDepositMediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNode",
      value: MsgDepositMediaNode.encode(message).finish()
    };
  }
};
function createBaseMsgDepositMediaNodeResponse(): MsgDepositMediaNodeResponse {
  return {
    medianodeId: "",
    totalDeposit: undefined,
    medianodeStatus: ""
  };
}
export const MsgDepositMediaNodeResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNodeResponse",
  encode(message: MsgDepositMediaNodeResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.medianodeId !== "") {
      writer.uint32(10).string(message.medianodeId);
    }
    if (message.totalDeposit !== undefined) {
      Coin.encode(message.totalDeposit, writer.uint32(18).fork()).ldelim();
    }
    if (message.medianodeStatus !== "") {
      writer.uint32(26).string(message.medianodeStatus);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgDepositMediaNodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDepositMediaNodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.medianodeId = reader.string();
          break;
        case 2:
          message.totalDeposit = Coin.decode(reader, reader.uint32());
          break;
        case 3:
          message.medianodeStatus = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgDepositMediaNodeResponse>, I>>(object: I): MsgDepositMediaNodeResponse {
    const message = createBaseMsgDepositMediaNodeResponse();
    message.medianodeId = object.medianodeId ?? "";
    if (object.totalDeposit !== undefined && object.totalDeposit !== null) {
      message.totalDeposit = Coin.fromPartial(object.totalDeposit);
    }
    message.medianodeStatus = object.medianodeStatus ?? "";
    return message;
  },
  fromAmino(object: MsgDepositMediaNodeResponseAmino): MsgDepositMediaNodeResponse {
    const message = createBaseMsgDepositMediaNodeResponse();
    if (object.medianode_id !== undefined && object.medianode_id !== null) {
      message.medianodeId = object.medianode_id;
    }
    if (object.total_deposit !== undefined && object.total_deposit !== null) {
      message.totalDeposit = Coin.fromAmino(object.total_deposit);
    }
    if (object.medianode_status !== undefined && object.medianode_status !== null) {
      message.medianodeStatus = object.medianode_status;
    }
    return message;
  },
  toAmino(message: MsgDepositMediaNodeResponse): MsgDepositMediaNodeResponseAmino {
    const obj: any = {};
    obj.medianode_id = message.medianodeId === "" ? undefined : message.medianodeId;
    obj.total_deposit = message.totalDeposit ? Coin.toAmino(message.totalDeposit) : undefined;
    obj.medianode_status = message.medianodeStatus === "" ? undefined : message.medianodeStatus;
    return obj;
  },
  fromAminoMsg(object: MsgDepositMediaNodeResponseAminoMsg): MsgDepositMediaNodeResponse {
    return MsgDepositMediaNodeResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgDepositMediaNodeResponseProtoMsg): MsgDepositMediaNodeResponse {
    return MsgDepositMediaNodeResponse.decode(message.value);
  },
  toProto(message: MsgDepositMediaNodeResponse): Uint8Array {
    return MsgDepositMediaNodeResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgDepositMediaNodeResponse): MsgDepositMediaNodeResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgDepositMediaNodeResponse",
      value: MsgDepositMediaNodeResponse.encode(message).finish()
    };
  }
};
function createBaseMsgCloseMediaNode(): MsgCloseMediaNode {
  return {
    mediaNodeId: "",
    sender: ""
  };
}
export const MsgCloseMediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNode",
  encode(message: MsgCloseMediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgCloseMediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCloseMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.sender = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgCloseMediaNode>, I>>(object: I): MsgCloseMediaNode {
    const message = createBaseMsgCloseMediaNode();
    message.mediaNodeId = object.mediaNodeId ?? "";
    message.sender = object.sender ?? "";
    return message;
  },
  fromAmino(object: MsgCloseMediaNodeAmino): MsgCloseMediaNode {
    const message = createBaseMsgCloseMediaNode();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.sender !== undefined && object.sender !== null) {
      message.sender = object.sender;
    }
    return message;
  },
  toAmino(message: MsgCloseMediaNode): MsgCloseMediaNodeAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.sender = message.sender === "" ? undefined : message.sender;
    return obj;
  },
  fromAminoMsg(object: MsgCloseMediaNodeAminoMsg): MsgCloseMediaNode {
    return MsgCloseMediaNode.fromAmino(object.value);
  },
  toAminoMsg(message: MsgCloseMediaNode): MsgCloseMediaNodeAminoMsg {
    return {
      type: "OmniFlix/close-medianode",
      value: MsgCloseMediaNode.toAmino(message)
    };
  },
  fromProtoMsg(message: MsgCloseMediaNodeProtoMsg): MsgCloseMediaNode {
    return MsgCloseMediaNode.decode(message.value);
  },
  toProto(message: MsgCloseMediaNode): Uint8Array {
    return MsgCloseMediaNode.encode(message).finish();
  },
  toProtoMsg(message: MsgCloseMediaNode): MsgCloseMediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNode",
      value: MsgCloseMediaNode.encode(message).finish()
    };
  }
};
function createBaseMsgCloseMediaNodeResponse(): MsgCloseMediaNodeResponse {
  return {};
}
export const MsgCloseMediaNodeResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNodeResponse",
  encode(_: MsgCloseMediaNodeResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgCloseMediaNodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCloseMediaNodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgCloseMediaNodeResponse>, I>>(_: I): MsgCloseMediaNodeResponse {
    const message = createBaseMsgCloseMediaNodeResponse();
    return message;
  },
  fromAmino(_: MsgCloseMediaNodeResponseAmino): MsgCloseMediaNodeResponse {
    const message = createBaseMsgCloseMediaNodeResponse();
    return message;
  },
  toAmino(_: MsgCloseMediaNodeResponse): MsgCloseMediaNodeResponseAmino {
    const obj: any = {};
    return obj;
  },
  fromAminoMsg(object: MsgCloseMediaNodeResponseAminoMsg): MsgCloseMediaNodeResponse {
    return MsgCloseMediaNodeResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgCloseMediaNodeResponseProtoMsg): MsgCloseMediaNodeResponse {
    return MsgCloseMediaNodeResponse.decode(message.value);
  },
  toProto(message: MsgCloseMediaNodeResponse): Uint8Array {
    return MsgCloseMediaNodeResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgCloseMediaNodeResponse): MsgCloseMediaNodeResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgCloseMediaNodeResponse",
      value: MsgCloseMediaNodeResponse.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateParams(): MsgUpdateParams {
  return {
    authority: "",
    params: Params.fromPartial({})
  };
}
export const MsgUpdateParams = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParams",
  encode(message: MsgUpdateParams, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;
        case 2:
          message.params = Params.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateParams>, I>>(object: I): MsgUpdateParams {
    const message = createBaseMsgUpdateParams();
    message.authority = object.authority ?? "";
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromPartial(object.params);
    }
    return message;
  },
  fromAmino(object: MsgUpdateParamsAmino): MsgUpdateParams {
    const message = createBaseMsgUpdateParams();
    if (object.authority !== undefined && object.authority !== null) {
      message.authority = object.authority;
    }
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromAmino(object.params);
    }
    return message;
  },
  toAmino(message: MsgUpdateParams): MsgUpdateParamsAmino {
    const obj: any = {};
    obj.authority = message.authority === "" ? undefined : message.authority;
    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    return obj;
  },
  fromAminoMsg(object: MsgUpdateParamsAminoMsg): MsgUpdateParams {
    return MsgUpdateParams.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgUpdateParamsProtoMsg): MsgUpdateParams {
    return MsgUpdateParams.decode(message.value);
  },
  toProto(message: MsgUpdateParams): Uint8Array {
    return MsgUpdateParams.encode(message).finish();
  },
  toProtoMsg(message: MsgUpdateParams): MsgUpdateParamsProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParams",
      value: MsgUpdateParams.encode(message).finish()
    };
  }
};
function createBaseMsgUpdateParamsResponse(): MsgUpdateParamsResponse {
  return {};
}
export const MsgUpdateParamsResponse = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParamsResponse",
  encode(_: MsgUpdateParamsResponse, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateParamsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateParamsResponse>, I>>(_: I): MsgUpdateParamsResponse {
    const message = createBaseMsgUpdateParamsResponse();
    return message;
  },
  fromAmino(_: MsgUpdateParamsResponseAmino): MsgUpdateParamsResponse {
    const message = createBaseMsgUpdateParamsResponse();
    return message;
  },
  toAmino(_: MsgUpdateParamsResponse): MsgUpdateParamsResponseAmino {
    const obj: any = {};
    return obj;
  },
  fromAminoMsg(object: MsgUpdateParamsResponseAminoMsg): MsgUpdateParamsResponse {
    return MsgUpdateParamsResponse.fromAmino(object.value);
  },
  fromProtoMsg(message: MsgUpdateParamsResponseProtoMsg): MsgUpdateParamsResponse {
    return MsgUpdateParamsResponse.decode(message.value);
  },
  toProto(message: MsgUpdateParamsResponse): Uint8Array {
    return MsgUpdateParamsResponse.encode(message).finish();
  },
  toProtoMsg(message: MsgUpdateParamsResponse): MsgUpdateParamsResponseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MsgUpdateParamsResponse",
      value: MsgUpdateParamsResponse.encode(message).finish()
    };
  }
};
/** Msg defines the medianode Msg service. */
export interface Msg {
  /** RegisterMediaNode registers a new media node */
  RegisterMediaNode(request: MsgRegisterMediaNode): Promise<MsgRegisterMediaNodeResponse>;
  /** UpdateMediaNode updates an existing media node */
  UpdateMediaNode(request: MsgUpdateMediaNode): Promise<MsgUpdateMediaNodeResponse>;
  /** LeaseMediaNode creates a new lease for a media node */
  LeaseMediaNode(request: MsgLeaseMediaNode): Promise<MsgLeaseMediaNodeResponse>;
  /** CancelLease cancels an active lease */
  CancelLease(request: MsgCancelLease): Promise<MsgCancelLeaseResponse>;
  /** ExtendLease Extends lease with additional hours */
  ExtendLease(request: MsgExtendLease): Promise<MsgExtendLeaseResponse>;
  /** DepositMediaNode deposits funds for a media node */
  DepositMediaNode(request: MsgDepositMediaNode): Promise<MsgDepositMediaNodeResponse>;
  /** CloseMediaNode closes a media node */
  CloseMediaNode(request: MsgCloseMediaNode): Promise<MsgCloseMediaNodeResponse>;
  /** UpdateParams */
  UpdateParams(request: MsgUpdateParams): Promise<MsgUpdateParamsResponse>;
}
export class MsgClientImpl implements Msg {
  private readonly rpc: Rpc;
  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.RegisterMediaNode = this.RegisterMediaNode.bind(this);
    this.UpdateMediaNode = this.UpdateMediaNode.bind(this);
    this.LeaseMediaNode = this.LeaseMediaNode.bind(this);
    this.CancelLease = this.CancelLease.bind(this);
    this.ExtendLease = this.ExtendLease.bind(this);
    this.DepositMediaNode = this.DepositMediaNode.bind(this);
    this.CloseMediaNode = this.CloseMediaNode.bind(this);
    this.UpdateParams = this.UpdateParams.bind(this);
  }
  RegisterMediaNode(request: MsgRegisterMediaNode): Promise<MsgRegisterMediaNodeResponse> {
    const data = MsgRegisterMediaNode.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "RegisterMediaNode", data);
    return promise.then(data => MsgRegisterMediaNodeResponse.decode(new BinaryReader(data)));
  }
  UpdateMediaNode(request: MsgUpdateMediaNode): Promise<MsgUpdateMediaNodeResponse> {
    const data = MsgUpdateMediaNode.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "UpdateMediaNode", data);
    return promise.then(data => MsgUpdateMediaNodeResponse.decode(new BinaryReader(data)));
  }
  LeaseMediaNode(request: MsgLeaseMediaNode): Promise<MsgLeaseMediaNodeResponse> {
    const data = MsgLeaseMediaNode.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "LeaseMediaNode", data);
    return promise.then(data => MsgLeaseMediaNodeResponse.decode(new BinaryReader(data)));
  }
  CancelLease(request: MsgCancelLease): Promise<MsgCancelLeaseResponse> {
    const data = MsgCancelLease.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "CancelLease", data);
    return promise.then(data => MsgCancelLeaseResponse.decode(new BinaryReader(data)));
  }
  ExtendLease(request: MsgExtendLease): Promise<MsgExtendLeaseResponse> {
    const data = MsgExtendLease.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "ExtendLease", data);
    return promise.then(data => MsgExtendLeaseResponse.decode(new BinaryReader(data)));
  }
  DepositMediaNode(request: MsgDepositMediaNode): Promise<MsgDepositMediaNodeResponse> {
    const data = MsgDepositMediaNode.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "DepositMediaNode", data);
    return promise.then(data => MsgDepositMediaNodeResponse.decode(new BinaryReader(data)));
  }
  CloseMediaNode(request: MsgCloseMediaNode): Promise<MsgCloseMediaNodeResponse> {
    const data = MsgCloseMediaNode.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "CloseMediaNode", data);
    return promise.then(data => MsgCloseMediaNodeResponse.decode(new BinaryReader(data)));
  }
  UpdateParams(request: MsgUpdateParams): Promise<MsgUpdateParamsResponse> {
    const data = MsgUpdateParams.encode(request).finish();
    const promise = this.rpc.request("OmniFlix.medianode.v1beta1.Msg", "UpdateParams", data);
    return promise.then(data => MsgUpdateParamsResponse.decode(new BinaryReader(data)));
  }
}